import * as Yup from 'yup';

const equipmentItemSchema = Yup.object().shape({
  brand: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
  model: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD')
});

export default Yup.lazy(values => {
  const isMultiEquipment = values?.equipmentsList?.length > 1;
  if (isMultiEquipment) {
    return Yup.object().shape({
      equipments: Yup.array()
        .of(equipmentItemSchema)
        .required('SCHEMA_ERRORS.REQUIRED_FIELD')
        .min(1)
    });
  }
  return Yup.object().shape({
    equipment: Yup.object().shape({
      brand: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD'),
      model: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD')
    })
  });
});
